<template>
	<div class="sns-sharing">
		<ul class="share-items">
			<!-- <li class="share-item">
				<ShareNetwork
					network="facebook"
					:url="url"
					:title="`【クレハ検定 5問中${yourTotalScore}問正解！】\nクレハの理解度は…\n\n${yourLevel}レベルです\n\nあなたのクレハの理解度は何レベル？\n気になったら「クレハ検定〜環境と社会への取り組み編〜」に挑戦！`"
				>
					<img src="../assets/img/kurehaTest/icon_fb.svg" alt="Facebook" width="80" height="80" />
				</ShareNetwork>
			</li> -->
			<li class="share-item">
				<ShareNetwork
					network="twitter"
					:url="url"
					:title="`【クレハ検定 5問中${yourTotalScore}問正解！】\nクレハの理解度は…\n\n${yourLevel}レベルです\n\nあなたのクレハの理解度は何レベル？\n気になったら「クレハ検定〜環境と社会への取り組み編〜」に挑戦！`"
				>
					<img src="../assets/img/kurehaTest/icon_twitter.svg" alt="Twitter" width="80" height="80" />
				</ShareNetwork>
			</li>
			<li class="share-item">
				<ShareNetwork
					network="line"
					:url="url"
					:title="`【クレハ検定 5問中${yourTotalScore}問正解！】\nクレハの理解度は…\n\n${yourLevel}レベルです\n\nあなたのクレハの理解度は何レベル？\n気になったら「クレハ検定〜環境と社会への取り組み編〜」に挑戦！`"
				>
					<img src="../assets/img/kurehaTest/icon_line.svg" alt="Line" width="80" height="80" />
				</ShareNetwork>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'sns-sharing',
	props: {
		imgSrc: {
			type: String,
			default: '',
		},
		url: {
			type: String,
			default: 'https://www.kureha.co.jp/recruit/kureha-test',
		},
		yourTotalScore: {
			type: Number,
			default: 0,
		},
		yourLevel: {
			type: String,
			default: 'クレラップの薄さ',
		},
	},
};
</script>

<style lang="scss">
.share-items {
	display: flex;
	align-items: center;
}
.share-item {
	width: 40px;
	@media print, screen and (min-width: 901px) {
		width: 50px;
	}
	& + & {
		margin-left: 20px;
	}
}
</style>
